<div class="bg overflow-auto" [style.background-image]="currentBackground">
  <app-start (onStartClicked)="start = false" *ngIf="start"></app-start>
  <app-overview *ngIf="start === false" (currentView)="changeBackground($event)"></app-overview>
</div>
